// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RenderLoader_container__h9g8h {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  pointer-events: none;
  background-color: #00000044;
  z-index: 1;
}

.RenderLoader_innerContainer__nd\\+3s {
  display: flex;
  flex-grow: 1;
  align-items: center;
}

.RenderLoader_loader__5WrdK,
.RenderLoader_loader__5WrdK:before,
.RenderLoader_loader__5WrdK:after {
  background: #ffffff;
  animation: RenderLoader_load1__0je6m 1s infinite ease-in-out;
  width: 1em;
  height: 4em;
}
.RenderLoader_loader__5WrdK {
  color: #ffffff;
  text-indent: -9999em;
  margin: 88px auto;
  position: relative;
  font-size: 11px;
  transform: translateZ(0);
  animation-delay: -0.16s;
}
.RenderLoader_loader__5WrdK:before,
.RenderLoader_loader__5WrdK:after {
  position: absolute;
  top: 0;
  content: "";
}
.RenderLoader_loader__5WrdK:before {
  left: -1.5em;
  animation-delay: -0.32s;
}
.RenderLoader_loader__5WrdK:after {
  left: 1.5em;
}
@keyframes RenderLoader_load1__0je6m {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 4em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 5em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ThreeJS/RenderLoader/RenderLoader.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EAEnB,4DAAwC;EACxC,UAAU;EACV,WAAW;AACb;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EAGf,wBAAwB;EAExB,uBAAuB;AACzB;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;AACA;EACE,YAAY;EAEZ,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AAaA;EACE;;;IAGE,eAAe;IACf,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;AACF","sourcesContent":[".container {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  pointer-events: none;\n  background-color: #00000044;\n  z-index: 1;\n}\n\n.innerContainer {\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.loader,\n.loader:before,\n.loader:after {\n  background: #ffffff;\n  -webkit-animation: load1 1s infinite ease-in-out;\n  animation: load1 1s infinite ease-in-out;\n  width: 1em;\n  height: 4em;\n}\n.loader {\n  color: #ffffff;\n  text-indent: -9999em;\n  margin: 88px auto;\n  position: relative;\n  font-size: 11px;\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  transform: translateZ(0);\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n.loader:before,\n.loader:after {\n  position: absolute;\n  top: 0;\n  content: \"\";\n}\n.loader:before {\n  left: -1.5em;\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n.loader:after {\n  left: 1.5em;\n}\n@-webkit-keyframes load1 {\n  0%,\n  80%,\n  100% {\n    box-shadow: 0 0;\n    height: 4em;\n  }\n  40% {\n    box-shadow: 0 -2em;\n    height: 5em;\n  }\n}\n@keyframes load1 {\n  0%,\n  80%,\n  100% {\n    box-shadow: 0 0;\n    height: 4em;\n  }\n  40% {\n    box-shadow: 0 -2em;\n    height: 5em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RenderLoader_container__h9g8h`,
	"innerContainer": `RenderLoader_innerContainer__nd+3s`,
	"loader": `RenderLoader_loader__5WrdK`,
	"load1": `RenderLoader_load1__0je6m`
};
export default ___CSS_LOADER_EXPORT___;
